// ** Custom Components
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardBody } from "components/layout/Card/CardBody";

// ** User Components
import DescriptionInfo from "./DescriptionInfo";
import SearchInfo from "./SearchInfo";
import PreferencesInfo from "./PreferencesInfo";
import Links from "./Links";
import DataInfo from "./DataInfo";

// ** Hooks
import { useMemoizedUser } from "hooks/useMeMoizedUser";

// #####################################################

const UserProfileInfo = () => {
	const user = useMemoizedUser();

	const isSearchVisible =
		user?.searchSexArray?.length !== 0 ||
		user?.searchAgeObject?.from !== null ||
		user?.searchAgeObject?.to !== null ||
		user?.searchForArray?.length !== 0;

	const isPreferencesVisible = user?.tastesArray?.length !== 0;

	return (
		<CardWrapper>
			<CardBody>
				<DescriptionInfo user={user} showFullText />
				<Links user={user} />
				{isSearchVisible ? <SearchInfo user={user} /> : null}
				{isPreferencesVisible ? (
					<PreferencesInfo
						user={user}
						isSearchVisible={isSearchVisible}
					/>
				) : null}
				<DataInfo
					user={user}
					isSearchVisible={isPreferencesVisible || isSearchVisible}
				/>
			</CardBody>
		</CardWrapper>
	);
};

// #####################################################

export default UserProfileInfo;

// #####################################################
